module.exports = __webpack_public_path__ + "static/media/fz_schdviewrobotverified_pt_PT.50f302b1.png";